import './Newsletter.css';
import React, { useState } from 'react';
import AlreadySubscribedMessage from './AlreadySubscribedMessage'
import NewSubscribedMessage from './NewSubscribedMessage'

import { Link } from 'gatsby';
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';
import addToMailchimp from 'gatsby-plugin-mailchimp';
export default ({}) => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(false);
  const [errorStatement, setErrorStatement] = useState('');

  function errorHandling(data) {
    console.log(data);
    setError(true);
  }

  const handleSubmit = () => {
    // Validation
    if (!email) {
      setError(true);
      setErrorStatement('email_required');
    } else if (email) {
      let lastAtPos = email.lastIndexOf('@');
      let lastDotPos = email.lastIndexOf('.');

      if (
        !(
          lastAtPos < lastDotPos &&
          lastAtPos > 0 &&
          email.indexOf('@@') == -1 &&
          lastDotPos > 2 &&
          email.length - lastDotPos > 2
        )
      ) {
        setError(true);
        setErrorStatement('invalid_email');
      } else {
        // Mailchip Add
        addToMailchimp(email).then(data => {
          if (data.result == 'error') {
            errorHandling(data);
            setErrorStatement('already_subscribed');
          } else {
            trackCustomEvent({
              category: 'Newsletter',
              action: 'Click',
              label: `Newsletter Click`,
            });
            setSubmitted(true);
          }
        });
      }
    }
  };


  return (
    <>
      <Link
        type="button"
        className="zoom-on-hover btn btn-primary mb-2"
        data-mdb-toggle="modal"
        data-mdb-target="#email"
        className="btn btn-outline-primary mt--20"
      >
        Subscribe
      </Link>
      {/* Modal */}
      <div
        style={{ zIndex: '100000' }}
        className="modal"
        id="email"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-body p-4">
              <button
                type="button"
                className="btn-close"
                data-mdb-dismiss="modal"
                aria-label="Close"
              ></button>

              {/* Start */}
              {submitted ? (
                <>
                    <NewSubscribedMessage/>
                </>
              ) : errorStatement == 'invalid_email' ? (
                <>
   

                <div className="section-title section-title-blue text-align-center">
                      <h6 className='fontSize:1rem'>Please Enter a valid email address</h6>
                    </div>


                <div className="row">
             
             <div className="col" data-tilt>
               <lottie-player
                 src="https://assets2.lottiefiles.com/packages/lf20_eBcQGa.json"
                 background="transparent"
                 speed="1"
                 style={{ width: '300px', height: '300px' }}
                 loop
                 autoplay
               ></lottie-player>
             </div>
     
             <div className="col">
               <span className="login100-form-title">Subscribe Newsletter</span>
     
               <div
                 className="wrap-input100 validate-input"
                 data-validate="Valid email is required: ex@abc.xyz"
               >
                 <input
                   onChange={e => setEmail(e.target.value)}
                   className="input100"
                   type="text"
                   placeholder="Email"
                 />
                 <span className="focus-input100"></span>
                 <span className="symbol-input100">
                   <i className="fa fa-envelope" aria-hidden="true"></i>
                 </span>
               </div>
     
               <div className="container-login100-form-btn">
                 <button
                   onClick={() => handleSubmit()}
                   type="submit"
                   className="btn btn-primary"
                 >
                   <span>Subscribe</span>
                 </button>
               </div>
             </div>
          
         </div>
                </>
              ) : errorStatement == 'email_required' ? (
                <>
             
              
              <div className="section-title section-title-blue text-align-center">
                      <h6 className='fontSize:1rem'>Email address is Required</h6>
                    </div>
              <div className="row">
             
             <div className="col" data-tilt>
               <lottie-player
                 src="https://assets2.lottiefiles.com/packages/lf20_eBcQGa.json"
                 background="transparent"
                 speed="1"
                 style={{ width: '300px', height: '300px' }}
                 loop
                 autoplay
               ></lottie-player>
             </div>
     
             <div className="col">
               <span className="login100-form-title">Subscribe Newsletter</span>
     
               <div
                 className="wrap-input100 validate-input"
                 data-validate="Valid email is required: ex@abc.xyz"
               >
                 <input
                   onChange={e => setEmail(e.target.value)}
                   className="input100"
                   type="text"
                   placeholder="Email"
                 />
                 <span className="focus-input100"></span>
                 <span className="symbol-input100">
                   <i className="fa fa-envelope" aria-hidden="true"></i>
                 </span>
               </div>
     
               <div className="container-login100-form-btn">
                 <button
                   onClick={() => handleSubmit()}
                   type="submit"
                   className="btn btn-primary"
                 >
                   <span>Subscribe</span>
                 </button>
               </div>
             </div>
          
         </div>
              </>
              
              ) : errorStatement == 'already_subscribed' ? (
                <>
              <AlreadySubscribedMessage/>
                </>
              ) : (
                <>
                <div className="row">
             
             <div className="col" data-tilt>
               <lottie-player
                 src="https://assets2.lottiefiles.com/packages/lf20_eBcQGa.json"
                 background="transparent"
                 speed="1"
                 style={{ width: '300px', height: '300px' }}
                 loop
                 autoplay
               ></lottie-player>
             </div>
     
             <div className="col">
               <span className="login100-form-title">Subscribe Newsletter</span>
     
               <div
                 className="wrap-input100 validate-input"
                 data-validate="Valid email is required: ex@abc.xyz"
               >
                 <input
                   onChange={e => setEmail(e.target.value)}
                   className="input100"
                   type="text"
                   placeholder="Email"
                 />
                 <span className="focus-input100"></span>
                 <span className="symbol-input100">
                   <i className="fa fa-envelope" aria-hidden="true"></i>
                 </span>
               </div>
     
               <div className="container-login100-form-btn">
                 <button
                   onClick={() => handleSubmit()}
                   type="submit"
                   className="btn btn-primary"
                 >
                   <span>Subscribe</span>
                 </button>
               </div>
             </div>
          
         </div>
                </>
              )}
             
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
